import { useIntl } from "gatsby-plugin-intl"

const getStatusTypeDescription = (type, onlyId) => {
  const { formatMessage } = onlyId ? {} : useIntl()

  const typeMap = {
    ALL_TYPES: "allTypes",
    FUTURE: "future",
    CURRENT: "current",
    PAST: "past",
    OPPORTUNITY: "opportunity",
    PROJECT_PLANNING: "projectPlaning",
    CONSTRUCTION: "construction",
    PROMOTION_AND_OPERATIONS: "promotionAndOperations",
    EXITED: "exited",
  }

  const id = `statusTypes.${typeMap[type]}`
  return onlyId
    ? id
    : formatMessage({
        id,
      })
}

export default getStatusTypeDescription
